<template>
  <v-dialog
    class="dialog"
    v-model="isAudioNotAvailableDialog"
    :before-close="close"
    width="400px"
    persistent
    @click:outside="close"
  >
    <v-card class="dialog-content px-5 py-5" width="auto" color="#21343b" px-5 py-3>
      <v-row no-gutters>
        <div v-html="this.$t('noAudioDetectedConfirm')" class="txt-dialog-title"></div>
      </v-row>
      <v-row no-gutters class="btn-bottom mt-4" justify="center" align="center">
        <v-col>
          <v-btn block height="40" elevation="0" color="#869399" @click="close">{{ $t('cancel') }}</v-btn>
        </v-col>
        <v-col class="ml-2">
          <v-btn block height="40" elevation="0" color="#27cd8b" @click="done">{{ $t('continue') }}</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RequestResponseDialog',
  props: {
    isAudioNotAvailableDialog: Boolean,
  },
  methods: {
    close() {
      this.$emit('close')
    },
    done() {
      this.$emit('done')
    },
  },
  computed: {},
}
</script>

<style scoped>
.txt-dialog-title {
  font-size: 14px;
  color: white;
  align-self: center;
}

.dialog-content {
  border-radius: 10px;
}
.v-dialog__content {
  z-index: 204 !important;
}
.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
</style>
